import { render, staticRenderFns } from "./SmtpCredentials.vue?vue&type=template&id=6a7017da&scoped=true&lang=pug&"
import script from "./SmtpCredentials.vue?vue&type=script&lang=js&"
export * from "./SmtpCredentials.vue?vue&type=script&lang=js&"
import style0 from "./SmtpCredentials.vue?vue&type=style&index=0&id=6a7017da&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a7017da",
  null
  
)

/* custom blocks */
import block0 from "./SmtpCredentials.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports